import { Button, ComboBox, Icons, WideAlert } from '@components';
import { mdiCommentAlertOutline } from '@mdi/js';
import { CaminhosPDFService } from '@services';
import getYear from 'date-fns/getYear';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

export const InformeRendimentosResgateParcialPage = () => {
  const { matricula, token } = useSelector((state) => state.user.data);
  const DIB = useSelector((state) => state.plan.DIB?.data);
  const custom = useSelector((state) => state.configs.tema);
  const [semResultados, setSemResultados] = useState(false);
  const [loading, setLoading] = useState(false);
  const [habilitarBotao, setHabilitarBotao] = useState(true);
  const [anoSelecionado, setAnoSelecionado] = useState('');
  const opcoesAnos = () => {
    const anos = [];
    const anoDIB = Number(DIB.split('/')[2]) || 2024;
    for (
      let i = anoDIB < 2024 ? 2024 : anoDIB;
      i < getYear(new Date());
      i += 1
    ) {
      anos.push(i.toString());
    }
    return anos.sort((a, b) => {
      return b.localeCompare(a);
    });
  };

  useEffect(() => {
    if (anoSelecionado !== '') setHabilitarBotao(false);
  }, [anoSelecionado]);

  const gerarPDF = () => {
    setLoading(true);
    const caminhosPDFService = new CaminhosPDFService();

    caminhosPDFService
      .getInformeRendimentoResgate(matricula, token, anoSelecionado)
      .then((res) => {
        if (res.data.msgConsistencia) setSemResultados(true);
        else {
          const mimeType = res.headers['content-type'];
          const blob = new Blob([res.data], { type: mimeType });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Informe de rendimentos ${anoSelecionado}- ${matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch(() => {
        toast.error('Erro ao carregar o arquivo.');
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="card">
      <div className="card-body">
        <span className="fw-bold ts-10 mb-32 mb-md-5">
          Informe Anual de Rendimentos - Resgate Parcial
        </span>
        {semResultados && (
          <WideAlert className="mb-4 mt-4" iconClear={false}>
            <div className="d-block d-lg-flex align-items-center">
              <Icons
                path={mdiCommentAlertOutline}
                color="var(--primary-color)"
                size={2}
                style={{ marginRight: 4 }}
              />
              <p className="ts-16">
                <strong>Aviso importante:</strong> Não foi encontrato informe de
                rendimento para o ano escolhido.
              </p>
            </div>
          </WideAlert>
        )}
        <div className="row col-12 col-md-8 col-lg-6">
          <ComboBox
            color={custom.nomeCorPrincipal}
            label="Ano"
            className="mt-3 col-12 col-md6 col-lg-6"
            defaultValue={anoSelecionado}
            values={anoSelecionado}
            onChange={setAnoSelecionado}
            tooltip="Selecione o ano de referência"
            options={opcoesAnos().map((x) => {
              return { value: x, label: x };
            })}
          />
          <Button
            className="mt-4 col-2 col-lg-3"
            disabled={habilitarBotao || loading}
            onClick={gerarPDF}
          >
            {loading ? 'Carregando...' : 'Gerar informe de rendimentos'}
          </Button>
        </div>
      </div>
    </div>
  );
};
